import React from 'react';
import "react-datepicker/dist/react-datepicker.css";

const RoleManagementCard = (props) => {

    const { parentMenuList, setSelectedParent, values, handleCheck, errors } = props;
    return (
        <>
            <div className="row mt-2">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                        {parentMenuList?.length
                            ? parentMenuList?.map((itm, index) => (
                                <>
                                    <li class="nav-item" role="presentation">
                                        <a className={`nav-link ${index === 0 ? 'active' : ''}`} id={`sales-tab-${index}`} data-toggle="tab" href={`#sales${index}`} role="tab" aria-controls={`sales${index}`} aria-selected={index === 0 ? 'true' : 'false'} onClick={() => setSelectedParent(itm?.id)}>   {itm?.menuName}</a>
                                    </li>
                                </>
                            )) : ""}
                    </ul>
                    <div class="tab-content p-2" id="myTabContent">
                        {parentMenuList?.length ? (
                            parentMenuList?.map((itm, index) => (
                                <div
                                    className={`tab-pane fade ${index === 0 ? 'show active' : ''}`}
                                    id={`sales${index}`}
                                    role="tabpanel"
                                    aria-labelledby={`${index}-tab`}
                                    key={index}>
                                    <div className="row">
                                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div className="user-role-table">
                                                <table className="table table-striped table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Sub Menu</th>
                                                            <th scope="col" className="text-center">Add</th>
                                                            <th scope="col" className="text-center">View</th>
                                                            <th scope="col" className="text-center">Edit</th>
                                                            <th scope="col" className="text-center">Delete</th>
                                                            <th scope="col" className="text-center">Print</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {values?.rolePermissions?.length ? (
                                                            values?.rolePermissions?.map(
                                                                (itm, index) => (
                                                                    <tr key={index}>
                                                                        <td>{itm?.menuName}</td>
                                                                        <td>
                                                                            <div className="form-group pl-2 text-center">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    style={{ cursor: "pointer" }}
                                                                                    id="canAdd"
                                                                                    name="canAdd"
                                                                                    checked={itm?.canAdd}
                                                                                    value={itm?.canAdd}
                                                                                    onChange={(e) =>
                                                                                        handleCheck(e, index)
                                                                                    } />

                                                                                <label for="add"></label>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div className="form-group pl-0 text-center">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    style={{ cursor: "pointer" }}
                                                                                    id="canView"
                                                                                    name="canView"
                                                                                    value={itm?.canView}
                                                                                    checked={itm?.canView}
                                                                                    onChange={(e) =>
                                                                                        handleCheck(e, index)
                                                                                    } />

                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div className="form-group pl-0 text-center">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    style={{ cursor: "pointer" }}
                                                                                    id="canEdit"
                                                                                    name="canEdit"
                                                                                    checked={itm?.canEdit}
                                                                                    value={itm?.canEdit}
                                                                                    onChange={(e) =>
                                                                                        handleCheck(e, index)
                                                                                    } />

                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div className="form-group pl-0 text-center">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    style={{ cursor: "pointer" }}
                                                                                    id="canDelete"
                                                                                    name="canDelete"
                                                                                    checked={itm?.canDelete}
                                                                                    value={itm?.canDelete}
                                                                                    onChange={(e) =>
                                                                                        handleCheck(e, index)
                                                                                    } />

                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div className="form-group pl-0 text-center">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    style={{ cursor: "pointer" }}
                                                                                    id="canPrint"
                                                                                    name="canPrint"
                                                                                    checked={itm?.canPrint}
                                                                                    value={itm?.canPrint}
                                                                                    onChange={(e) =>
                                                                                        handleCheck(e, index)
                                                                                    } />
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            )
                                                        ) : (
                                                            <p className="pl-3 pt-3">No submenus available</p>
                                                        )}
                                                        {errors?.checked != "" && (
                                                            <p className="form-error">{errors?.checked} </p>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>))) : " "}
                    </div>
                </div>
            </div>
        </>
    )
}

export default RoleManagementCard